export default {"src":"/_next/static/media/credential-monitoring.8fb531fe.svg","height":431,"width":431,"blurWidth":0,"blurHeight":0};